import { useMemo } from 'react';
import apiClient from 'src/api/axiosClient';
import { GetMetricsApi, GetMetricsTotalsApi } from '../types';

export function useHomeApi() {
  return useMemo(
    () => ({
      getMetrics: ((params) =>
        apiClient.get(`/companies/metrics`, { params })) as GetMetricsApi,
      getMetricsTotals: ((params) =>
        apiClient.get(`/companies/metrics-totals`, { params })) as GetMetricsTotalsApi,
    }),
    [],
  );
}
